(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["DX-you-special-quiz-section"] && !window.DesignMode) return;
  try {
    
  
  document.addEventListener("DOMContentLoaded", function () {
    let currentQuestion = 1;
    let userAnswers = {};
    let partnerAnswers = {};
    let userGender;
    
    // Soru 1
    document.querySelectorAll(".DX-gender-answer").forEach(button => {
        button.addEventListener("click", function () {
            document.querySelectorAll(".DX-gender-answer").forEach(button => { button.classList.remove("active") });
            userAnswers.Cinsiyet = button.dataset.userGender;
            this.classList.add("active");
            if( userAnswers.Cinsiyet == "Kadın" ){
              document.querySelector("#DX-position-man-container").style.display = "none";
              document.querySelector("#DX-position-woman-container").style.display = "block";
              document.querySelector("#DX-position-man-partner-container").style.display = "block";
              document.querySelector("#DX-position-woman-partner-container").style.display = "none";
            } else {
              document.querySelector("#DX-position-man-container").style.display = "block";
              document.querySelector("#DX-position-woman-container").style.display = "none";
              document.querySelector("#DX-position-man-partner-container").style.display = "none";
              document.querySelector("#DX-position-woman-partner-container").style.display = "block";
            }
            setTimeout(moveToNextQuestion, 500);
        });
    });

    // Soru 2
    document.querySelectorAll(".DX-yesno-answer").forEach(button => {
        button.addEventListener("click", function () {
            document.querySelectorAll(".DX-yesno-answer").forEach(button => { button.classList.remove("active") });
            userAnswers.Partner = button.dataset.userPartner;
            this.classList.add("active");
            if (userAnswers.Partner === "Evet") {
                document.querySelectorAll(".DX-hbx-quiz-tab-container").forEach(tabs => {
                    tabs.style.display = "block"
                })
            } else {
                document.querySelectorAll(".DX-hbx-quiz-tab-container").forEach(tabs => {
                    tabs.style.display = "none"
                })
            }
            setTimeout(moveToNextQuestion, 500);
        });
    });

    // Soru 3    
    document.querySelectorAll(".DX-position-answer").forEach(button => {
        button.addEventListener("click", function () {
            if (document.querySelector("#main-position-tab").classList.contains("active")) {
                document.querySelectorAll('[data-user-position]').forEach(button => { button.classList.remove("active") });
                userAnswers.UykuPozisyonu = button.dataset.userSleep;
                this.classList.add("active");
                if (userAnswers.Partner === "Evet") {  // Eğer varsa bir kontrol
                    switchTab("#main-position-tab", "#partner-position-tab");
                    switchContent("#main-position-content", "#partner-position-content");
                } else {
                    setTimeout(moveToNextQuestion, 500);
                }
            } else {
                document.querySelectorAll('[data-partner-position]').forEach(button => { button.classList.remove("active") });
                partnerAnswers.UykuPozisyonu = button.dataset.partnerSleep;
                this.classList.add("active");
                setTimeout(moveToNextQuestion, 500);
            }
        });
    });


    // Soru 4
    document.querySelectorAll(".DX-height-answer").forEach(button => {
        button.addEventListener("click", function () {
            if (document.querySelector("#main-height-tab").classList.contains("active")) {
                document.querySelectorAll('[data-user-height]').forEach(button => { button.classList.remove("active") });
                userAnswers.Boy = button.dataset.userHeight;
                this.classList.add("active");
                if (userAnswers.Partner === "Evet") {
                    switchTab("#main-height-tab", "#partner-height-tab");
                    switchContent("#main-height-content", "#partner-height-content");
                } else {
                    setTimeout(moveToNextQuestion, 500);
                }
            } else {
                document.querySelectorAll('[data-partner-height]').forEach(button => { button.classList.remove("active") });
                partnerAnswers.Boy = button.dataset.partnerHeight;
                this.classList.add("active");
                setTimeout(moveToNextQuestion, 500);
            }
        });
    });

    // Soru 5
    document.querySelectorAll(".DX-weight-answer").forEach(button => {
        button.addEventListener("click", function () {
            if (document.querySelector("#main-weight-tab").classList.contains("active")) {
                document.querySelectorAll('[data-user-weight]').forEach(button => { button.classList.remove("active") });
                userAnswers.Kilo = button.dataset.userWeight;
                this.classList.add("active");
                if (userAnswers.Partner === "Evet") {
                    switchTab("#main-weight-tab", "#partner-weight-tab");
                    switchContent("#main-weight-content", "#partner-weight-content");
                } else {
                    setTimeout(moveToNextQuestion, 500);
                }
            } else {
                document.querySelectorAll('[data-partner-weight]').forEach(button => { button.classList.remove("active") });
                partnerAnswers.Kilo = button.dataset.partnerWeight;
                this.classList.add("active");
                setTimeout(moveToNextQuestion, 500);
            }
        });
    });

    // Soru 6
    document.querySelectorAll(".DX-age-answer").forEach(button => {
        button.addEventListener("click", function () {
            if (document.querySelector("#main-age-tab").classList.contains("active")) {
                document.querySelectorAll('[data-user-age]').forEach(button => { button.classList.remove("active") });
                userAnswers.Yaş = button.dataset.userAge;
                this.classList.add("active");
                if (userAnswers.Partner === "Evet") {
                    switchTab("#main-age-tab", "#partner-age-tab");
                    switchContent("#main-age-content", "#partner-age-content");
                } else {
                    setTimeout(moveToNextQuestion, 500);
                }
            } else {
                document.querySelectorAll('[data-partner-age]').forEach(button => { button.classList.remove("active") });
                partnerAnswers.Yaş = button.dataset.partnerAge;
                this.classList.add("active");
                setTimeout(moveToNextQuestion, 500);
            }
        });
    });

    // Soru 7
    document.querySelectorAll(".DX-pain-answer").forEach(button => {
        button.addEventListener("click", function () {
            if (document.querySelector("#main-pain-tab").classList.contains("active")) {
                document.querySelectorAll('[data-user-pain]').forEach(button => { button.classList.remove("active") });
                userAnswers.Ağrı = button.dataset.userPain;
                this.classList.add("active");
                if (userAnswers.Partner === "Evet") {
                    switchTab("#main-pain-tab", "#partner-pain-tab");
                    switchContent("#main-pain-content", "#partner-pain-content");
                } else {
                    setTimeout(moveToNextQuestion, 500);
                }
            } else {
                document.querySelectorAll('[data-partner-pain]').forEach(button => { button.classList.remove("active") });
                partnerAnswers.Ağrı = button.dataset.partnerPain;
                this.classList.add("active");
                setTimeout(moveToNextQuestion, 500);
            }
        });
    });

    // Soru 8
    document.querySelectorAll(".DX-allergy-answer").forEach(button => {
        button.addEventListener("click", function () {
            if (document.querySelector("#main-allergy-tab").classList.contains("active")) {
                document.querySelectorAll('[data-user-allergy]').forEach(button => { button.classList.remove("active") });
                userAnswers.Alerji = button.dataset.userAllergy;
                this.classList.add("active");
                if (userAnswers.Partner === "Evet") {
                    switchTab("#main-allergy-tab", "#partner-allergy-tab");
                    switchContent("#main-allergy-content", "#partner-allergy-content");
                } else {
                    setTimeout(moveToNextQuestion, 500);
                }
            } else {
                document.querySelectorAll('[data-partner-allergy]').forEach(button => { button.classList.remove("active") });
                partnerAnswers.Alerji = button.dataset.partnerAllergy;
                this.classList.add("active");
                setTimeout(moveToNextQuestion, 500);
            }
        });
    });

    // Soru 9
    document.querySelectorAll(".DX-sweat-answer").forEach(button => {
        button.addEventListener("click", function () {
            if (document.querySelector("#main-sweat-tab").classList.contains("active")) {
                document.querySelectorAll('[data-user-sweat]').forEach(button => { button.classList.remove("active") });
                userAnswers.Terleme = button.dataset.userSweat;
                this.classList.add("active");
                if (userAnswers.Partner === "Evet") {
                    switchTab("#main-sweat-tab", "#partner-sweat-tab");
                    switchContent("#main-sweat-content", "#partner-sweat-content");
                } else {
                    setTimeout(moveToNextQuestion, 500);
                }
            } else {
                document.querySelectorAll('[data-partner-sweat]').forEach(button => { button.classList.remove("active") });
                partnerAnswers.Terleme = button.dataset.partnerSweat;
                this.classList.add("active");
                setTimeout(moveToNextQuestion, 500);
            }
        });
    });

    // Soru 10
    document.querySelectorAll(".DX-activity-answer").forEach(button => {
        button.addEventListener("click", function () {
            if (document.querySelector("#main-activity-tab").classList.contains("active")) {
                document.querySelectorAll('[data-user-activity]').forEach(button => { button.classList.remove("active") });
                userAnswers.Aktiflik = button.dataset.userActivity;
                this.classList.add("active");
                if (userAnswers.Partner === "Evet") {
                    switchTab("#main-activity-tab", "#partner-activity-tab");
                    switchContent("#main-activity-content", "#partner-activity-content");
                } else {
                    setTimeout(moveToNextQuestion, 500);
                }
            } else {
                document.querySelectorAll('[data-partner-activity]').forEach(button => { button.classList.remove("active") });
                partnerAnswers.Aktiflik = button.dataset.partnerActivity;
                this.classList.add("active");
                setTimeout(moveToNextQuestion, 500);
            }
        });
    });

    // Soru 11
    document.querySelectorAll(".DX-visko-null-answer").forEach(button => {
        button.addEventListener("click", function () {
          document.querySelectorAll('[data-user-nullvisko]').forEach(button => { button.classList.remove("active") });
          this.classList.add("active");
          setTimeout(moveToNextQuestion, 500);
        });   
    });

    // Soru 12
    document.querySelectorAll(".DX-visko-answer").forEach(button => {
        button.addEventListener("click", function () {
            document.querySelectorAll('[data-user-visko]').forEach(button => { button.classList.remove("active") });
            this.classList.add("active");
            userAnswers.Visko = button.dataset.userVisko;
            saveToLocalStorage();
            determineFirstProduct(userAnswers.Boy, userAnswers.Kilo, partnerAnswers.Boy, partnerAnswers.Kilo, userAnswers.Terleme, userAnswers.Alerji, userAnswers.Aktiflik, userAnswers.Visko);    
        });
    });

    // Define all the tab pairs in an array
    const tabs = [
        { main: 'position', partner: 'position' },
        { main: 'height', partner: 'height' },
        { main: 'weight', partner: 'weight' },
        { main: 'age', partner: 'age' },
        { main: 'pain', partner: 'pain' },
        { main: 'allergy', partner: 'allergy' },
        { main: 'sweat', partner: 'sweat' },
        { main: 'activity', partner: 'activity' }
    ];

    // Function to set up event listeners for each tab pair
    tabs.forEach(tab => {
        document.querySelector(`#partner-${tab.partner}-tab`).addEventListener("click", function () {
            switchTab(`#main-${tab.main}-tab`, `#partner-${tab.partner}-tab`);
            switchContent(`#main-${tab.main}-content`, `#partner-${tab.partner}-content`);
        });
        document.querySelector(`#main-${tab.main}-tab`).addEventListener("click", function () {
            switchTab(`#partner-${tab.partner}-tab`, `#main-${tab.main}-tab`);
            switchContent(`#partner-${tab.partner}-content`, `#main-${tab.main}-content`);
        });
    });
    
    function moveToNextQuestion() {
        document.querySelector("#soru" + currentQuestion).style.display = "none";
        currentQuestion++;
        document.querySelector("#soru" + currentQuestion).style.display = "flex";
    }

    function moveToPreviousQuestion() {
        if (currentQuestion > 1) {  // 1. sorudan geri gidememeli.
            document.querySelector("#soru" + currentQuestion).style.display = "none";
            currentQuestion--;
            document.querySelector("#soru" + currentQuestion).style.display = "flex";
        }
    }
    function resetHbxQuiz() {
        document.querySelector("#soru" + currentQuestion).style.display = "none";
        currentQuestion = 1;
        document.querySelector("#soru" + currentQuestion).style.display = "flex";
    }
    document.getElementById("backButton").addEventListener("click", moveToPreviousQuestion);
    document.getElementById("resetButton").addEventListener("click", resetHbxQuiz);

    function switchTab(fromTab, toTab) {
        setTimeout(() => {
            document.querySelector(fromTab).classList.remove("active");
            document.querySelector(toTab).classList.add("active");
        }, 500);
    }

    function switchContent(fromContent, toContent) {
        setTimeout(() => {
            document.querySelector(fromContent).style.display = "none";
            document.querySelector(toContent).style.display = "flex";
        }, 500);
    }

    const quizCheckboxGroups = [
        { checkboxes: document.querySelectorAll('#boyun, #omuz, #sirtOmurga, #basen'), button: document.querySelector('.DX-pain-main-tab') },
        { checkboxes: document.querySelectorAll('#boyun2, #omuz2, #sirtOmurga2, #basen2'), button: document.querySelector('.DX-pain-partner-tab') }
    ];

    function updateButtonText(group) {
        const ilerleText = document.querySelector('.text-ilerle').textContent;
        const agriText = document.querySelector('.text-agri').textContent;
        group.button.textContent = Array.from(group.checkboxes).some(checkbox => checkbox.checked) ? ilerleText : agriText;
    }

    quizCheckboxGroups.forEach(group => {
        group.checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', () => updateButtonText(group));
        });
        updateButtonText(group);  // Optional: If you want to update the button text on page load
    });

    let loopCurrentLogo = 0;
    const dxYouLogos = document.querySelectorAll('.logo-to-loop');
    
    document.getElementById("startquiz").addEventListener("click", startToquiz);
    
    function startToquiz (){
      document.getElementById("DXquizcover").style.display = "none";
      document.getElementById("soru1").style.display = "flex";
      document.getElementById("backButton").style.display = "block";
    }
    
    function updateLogos() {
        dxYouLogos[loopCurrentLogo].style.display = 'none';
        loopCurrentLogo = (loopCurrentLogo + 1) % dxYouLogos.length;
        dxYouLogos[loopCurrentLogo].style.display = 'block';
    }

    // 1 saniyede bir güncelleme yap
    setInterval(updateLogos, 1000);

    async function determineFirstProduct(boy, kilo, pboy, pkilo, sweating, allergy, activity, visko) {
        try {
            const userEntry = firstProductData.find(e => e.boy === boy && e.kilo === kilo);
            const partnerEntry = firstProductData.find(e => e.boy === pboy && e.kilo === pkilo);
            let secondProduct;
            if (visko === 'Evet') {
              secondProduct = { product: 'Visco Topper' };
            } else {
                const fabricData = [
                    { sweating: 'Evet', allergy: 'Evet', activity: 'Evet', product: 'Fresh' },
                    { sweating: 'Evet', allergy: 'Evet', activity: 'Hayır', product: 'Fresh' },
                    { sweating: 'Evet', allergy: 'Hayır', activity: 'Evet', product: 'Fresh' },
                    { sweating: 'Evet', allergy: 'Hayır', activity: 'Hayır', product: 'Fresh' },
                    { sweating: 'Hayır', allergy: 'Hayır', activity: 'Evet', product: 'Energize' },
                    { sweating: 'Hayır', allergy: 'Evet', activity: 'Evet', product: 'Energize' },
                    { sweating: 'Hayır', allergy: 'Hayır', activity: 'Hayır', product: 'Probiotic' },
                    { sweating: 'Hayır', allergy: 'Evet', activity: 'Hayır', product: 'Probiotic' },
                ];
                secondProduct = fabricData.find(e => e.sweating === sweating && e.allergy === allergy && e.activity === activity);
            }

            if (!userEntry) {
                console.error('userEntry tanımsız:', boy, kilo);
                return null;
            }
            const userVKE = parseFloat(userEntry.vke.replace(',', '.'));
            if (userAnswers.Partner === "Evet") {
                const partnerVKE = parseFloat(partnerEntry.vke.replace(',', '.'));
                if (userVKE > partnerVKE) {
                    showTheResult(userEntry.product, secondProduct.product)
                } else {
                    showTheResult(partnerEntry.product, secondProduct.product)
                }
            } else {
                showTheResult(userEntry.product, secondProduct.product)
            }



        } catch (error) {
            console.error('Veri alınırken bir hata oluştu:', error);
            return null;
        }
    }

    // DOM elementlerini seçme
    const answerResults = document.getElementById('answerResults');
    const userAnswersList = document.getElementById('userAnswersList');
    const loading = document.getElementById('loading');
    const finalResult = document.getElementById('finalResult');
    const resultText = document.getElementById('resultText');

    function writeAnswerSequentially(answerList, answerObject, index = 0) {
        if (index < Object.keys(answerObject).length) {
            let key = Object.keys(answerObject)[index];
            let value = answerObject[key];

            // Eğer cevap undefined ise atla
            if (value === undefined) {
                writeAnswerSequentially(answerList, answerObject, index + 1);
                return;
            }

            answerList.textContent = `${key}: ${value}`;

            setTimeout(() => {
                answerList.textContent = ""; // yazıyı temizle
                writeAnswerSequentially(answerList, answerObject, index + 1); // sonraki cevabı yazdır
            }, 500); // 1.5 saniye arayla yazdırılan cevabı sil
        }
    }

    function loadResults() {
        document.querySelector("#soru" + currentQuestion).style.display = "none";
      document.getElementById("backButton").style.display = "none";
        answerResults.style.display = "flex";
        loading.style.display = "flex";  // spinner'ı göster
      

        writeAnswerSequentially(userAnswersList, userAnswers);

        setTimeout(() => {
            loading.style.display = "none";  // spinner'ı gizle
            answerResults.style.display = "none";
            finalResult.style.display = "flex";
            if (userAnswers.Partner === "Evet") {
                resultText.textContent = "Size ve eşinize en uygun yatak sonucu:";
            } else {resultText.textContent = "SONUÇ:";}
            
        }, 5000); // her cevap için 1.5 saniye

        
    }

    function saveToLocalStorage() {
        localStorage.setItem('userAnswers', JSON.stringify(userAnswers));
        localStorage.setItem('partnerAnswers', JSON.stringify(partnerAnswers));
        console.log("Answers saved to Local Storage!");
    }
    function showTheResult(firstpro, secondpro) {
        loadResults(firstpro);
        showImageBasedOnResponse(firstpro, secondpro);
    }

    function showImageBasedOnResponse(firstpro, secondpro) {
        let imageUrl = "";

        switch (firstpro) {
            case 'Yumuşak':
                imageUrl = "https://tr.hibboux.com/cdn/shop/files/Hibboux-YouMavi.jpg?v=1685438862&width=720";
                logoUrl = "https://cdn.shopify.com/s/files/1/0420/4580/0599/files/Varlik_1mint.png?v=1693940484";
                firmLevelUrl = "https://cdn.shopify.com/s/files/1/0420/4580/0599/files/yumusak_v2.png?v=1685541512";
                break;
            case 'Orta':
                imageUrl = "https://tr.hibboux.com/cdn/shop/files/Hibboux-YouSari.jpg?v=1685438862&width=720";
                logoUrl = "https://cdn.shopify.com/s/files/1/0420/4580/0599/files/Varlik_1yellow.png?v=1693940484";
                firmLevelUrl = "https://cdn.shopify.com/s/files/1/0420/4580/0599/files/orta_v2.png?v=1685541511";
                break;
            case 'Sert':
                imageUrl = "https://tr.hibboux.com/cdn/shop/files/Hibboux-YouKirmizi.jpg?v=1685438862&width=720";
                logoUrl = "https://cdn.shopify.com/s/files/1/0420/4580/0599/files/Varlik_1red.png?v=1693940484";
                firmLevelUrl = "https://cdn.shopify.com/s/files/1/0420/4580/0599/files/sert_v2.png?v=1685541511";
                break;
        }
        switch (secondpro) {
            case 'Fresh':
                fabricResultUrl = "https://cdn.shopify.com/s/files/1/0531/3547/4873/files/cairfull.svg?v=1679552687";
                break;
            case 'Probiotic':
                fabricResultUrl = "https://cdn.shopify.com/s/files/1/0531/3547/4873/files/purotex.svg?v=1679552687";
                break;
            case 'Energize':
                fabricResultUrl = "https://cdn.shopify.com/s/files/1/0531/3547/4873/files/vitalize.svg?v=1679552687";
                break;
            case 'Visco Topper':
                fabricResultUrl = "https://cdn.shopify.com/s/files/1/0420/4580/0599/files/visco.svg?v=1714052803";
                break;
        }
        
      
        firstVariant.forEach(button => {
            button.addEventListener('click', function() {
              
              // Diğer butonlardan 'selected' sınıfını kaldır
              firstVariant.forEach(btn => btn.classList.remove('selected'));
              
              // Tıklanan butona 'selected' sınıfını ekle
              this.classList.add('selected');
              
              // Tıklanan butonun data-value değerini fVariant değişkenine ata
               olcu = this.getAttribute('data-value');
               
              
            });
          });
        
      
        if (imageUrl) {
            document.getElementById("dxYouLogoLoop").innerHTML = '';
            var lastResultLogo = document.createElement('img');
            lastResultLogo.src = logoUrl;
            lastResultLogo.classList.add('logo-to-loop');
            document.getElementById("dxYouLogoLoop").appendChild(lastResultLogo);
            
            document.getElementById("firstproimgID").src = firmLevelUrl;
            document.getElementById("firstprospanID").textContent = firstpro;
            document.getElementById("secondproimgID").src = fabricResultUrl;
            document.getElementById("secondprospanID").textContent = secondpro;
            document.getElementById('resultImage').src = imageUrl; // 'resultImage' is the ID of the image element you want to change.
        } else {
            console.error("Invalid combination of firstpro and secondpro");
        }

      let productUrl = "";

      const variantMap = {
        'Fresh': {
          'Yumuşak': 'https://tr.hibboux.com/products/you-hybrid-yatak-fresh-kilif?variant=55553365246217',
          'Orta': 'https://tr.hibboux.com/products/you-hybrid-yatak-fresh-kilif?variant=55553365278985',
          'Sert': 'https://tr.hibboux.com/products/you-hybrid-yatak-fresh-kilif?variant=55553365311753',
        },
        'Probiotic': {
          'Yumuşak': 'https://tr.hibboux.com/products/you-hybrid-yatak-probiotic-kilif?variant=55553029275913',
          'Orta': 'https://tr.hibboux.com/products/you-hybrid-yatak-probiotic-kilif?variant=55553029308681',
          'Sert': 'https://tr.hibboux.com/products/you-hybrid-yatak-probiotic-kilif?variant=55553029341449',
        },
        'Energize': {
          'Yumuşak': 'https://tr.hibboux.com/products/you-hybrid-yatak-energize-kilif?variant=55553348108553',
          'Orta': 'https://tr.hibboux.com/products/you-hybrid-yatak-energize-kilif?variant=55553348141321',
          'Sert': 'https://tr.hibboux.com/products/you-hybrid-yatak-energize-kilif?variant=55553348174089',
        },
        'Visco Topper': {
          'Yumuşak': 'https://tr.hibboux.com/products/you-hybrid-yatak-visco-topper?variant=55553367965961',
          'Orta': 'https://tr.hibboux.com/products/you-hybrid-yatak-visco-topper?variant=55553367998729',
          'Sert': 'https://tr.hibboux.com/products/you-hybrid-yatak-visco-topper?variant=55553368031497',
        }
      };
      
      if (variantMap[secondpro] && variantMap[secondpro][firstpro]) {
        productUrl = variantMap[secondpro][firstpro];
      } else {
        productUrl = "#"; // fallback
      }
      
      // Add to Cart butonuna linki ata
      document.getElementById("addtocartbutton").setAttribute("href", productUrl);

    }
    
    const firstVariant = document.querySelectorAll("#first-option-buttons");
    const firstVariantSelectMenu = document.querySelector('#selecttype-first-product');
    const secondVariantSelectMenu = document.querySelector('#selecttype-second-product');
    const productPrice = document.getElementById('DX-product-price');
    const productComparePrice = document.getElementById('DX-product-compare-price');
    var firstoptions = firstVariantSelectMenu.querySelectorAll('option');
    var secondoptions = secondVariantSelectMenu.querySelectorAll('option');
    var fVariant,
        sVariant,
        tVariant,
        olcu,
        customhrefLink,
        firstSelectedProduct,
        firstProductfound,
        firstProductVariantid,
        secondSelectedProduct,
        secondProductfound,
        secondProductVariantid,
        totalFProductPrice,
        totalFProductComparePrice,
        totalSProductPrice,
        totalSProductComparePrice,
        totalFinalPrice,
        totalFinalComparePrice;
});

    

  } catch(e) { console.error(e); }
})();
})();
